"use client";

import { FC } from "react";
import { Header } from "@/components/pages/Landings/Header";
import Footer from "@/components/pages/Landings/Footer";
import { useTranslations } from "next-intl";

const PrivacyPolicyPage: FC = () => {
  const t = useTranslations();

  return (
    <div
      style={{
        background:
          "linear-gradient(219deg, rgba(242, 121, 40, 0.10) -0.42%, rgba(242, 121, 40, 0.06) -0.41%, rgba(242, 121, 40, 0.00) 78.67%)",
      }}
    >
      <Header />
      <div className="mx-auto max-w-[980px] px-[20px] pt-[96px] md:pt-[156px] pb-[64px] md:pb-[96px]">
        <div className="flex flex-col md:flex-row items-center gap-[24px] mb-[48px] md:mb-[92px]">
          <div className="border-[10px] md:border-[12px] border-primary-100 shrink-0 h-[60px] md:h-[80px] w-[60px] md:w-[80px] bg-primary-200 rounded-full flex items-center justify-center text-[24px] md:text-[36px] shadow-[0px_5.833px_21.875px_0px_rgba(14,9,7,0.11)]">
            🏠
          </div>
          <h1 className="text-[36px] md:text-[64px] font-bold leading-[36px] md:leading-[64px]">
            {t("PrivacyPolicy.title")}
          </h1>
        </div>
        <div className="text-black-400">
          <h2 className="text-[20px] font-bold mt-[30px]">
            {t("PrivacyPolicy.section1Title")}
          </h2>
          <p className="leading-[24px]">{t("PrivacyPolicy.section1Text")}</p>
          <h2 className="text-[20px] font-bold mt-[30px]">
            {t("PrivacyPolicy.section2Title")}
          </h2>
          <p className="leading-[24px]">{t("PrivacyPolicy.section2Text")}</p>
          <h2 className="text-[20px] font-bold mt-[30px]">
            {t("PrivacyPolicy.section3Title")}
          </h2>
          <div className="pl-[20px]">
            <h3 className="text-[16px] font-bold mt-[10px]">
              {t("PrivacyPolicy.section3SubTitle1")}
            </h3>
            <p className="leading-[24px]">{t("PrivacyPolicy.section3Text1")}</p>
            <h3 className="text-[16px] font-bold mt-[10px]">
              {t("PrivacyPolicy.section3SubTitle2")}
            </h3>
            <p className="leading-[24px]">{t("PrivacyPolicy.section3Text2")}</p>
            <h3 className="text-[16px] font-bold mt-[10px]">
              {t("PrivacyPolicy.section3SubTitle3")}
            </h3>
            <p className="leading-[24px]">{t("PrivacyPolicy.section3Text3")}</p>
            <h3 className="text-[16px] font-bold mt-[10px]">
              {t("PrivacyPolicy.section3SubTitle4")}
            </h3>
            <p className="leading-[24px]">{t("PrivacyPolicy.section3Text4")}</p>
            <h3 className="text-[16px] font-bold mt-[10px]">
              {t("PrivacyPolicy.section3SubTitle5")}
            </h3>
            <p className="leading-[24px]">{t("PrivacyPolicy.section3Text5")}</p>
          </div>
          <h2 className="text-[20px] font-bold mt-[30px]">
            {t("PrivacyPolicy.section4Title")}
          </h2>
          <p className="leading-[24px]">{t("PrivacyPolicy.section4Text")}</p>
          <h2 className="text-[20px] font-bold mt-[30px]">
            {t("PrivacyPolicy.section5Title")}
          </h2>
          <p className="leading-[24px]">{t("PrivacyPolicy.section5Text")}</p>
          <h2 className="text-[20px] font-bold mt-[30px]">
            {t("PrivacyPolicy.section6Title")}
          </h2>
          <p className="leading-[24px]">{t("PrivacyPolicy.section6Text")}</p>
          <h2 className="text-[20px] font-bold mt-[30px]">
            {t("PrivacyPolicy.section7Title")}
          </h2>
          <p className="leading-[24px]">{t("PrivacyPolicy.section7Text")}</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
